import { TrendingUp } from "lucide-react";

import { DashboardHub } from "@/features/dashboard/hub";
import { usePermissions } from "@/features/rbac/hooks/usePermissions";

/**
 * Hub de métricas multi-dominio (overview del día).
 */
export default function Dashboard(): React.JSX.Element {
  const { can, isLoading } = usePermissions();

  if (isLoading) {
    return (
      <div className="flex min-h-[400px] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
      </div>
    );
  }

  // Panel simplificado: quien solo tiene bioanálisis no llega al hub completo.
  const showBioanalystPanel = can("bioanalysis:view") && !can("imagings:list");

  if (showBioanalystPanel) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center space-y-4 text-center">
        <div className="rounded-full bg-primary/10 p-6">
          <TrendingUp className="h-12 w-12 text-primary" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
          Panel de Bioanalista
        </h1>
        <p className="max-w-md text-xl text-gray-600 dark:text-gray-400">
          Bienvenido al sistema. Esta es una vista simplificada para pruebas del perfil
          bionalist.
        </p>
      </div>
    );
  }

  return <DashboardHub />;
}
